import { render } from "./DraggedItem.vue?vue&type=template&id=701acdcf&scoped=true"
import script from "./DraggedItem.vue?vue&type=script&lang=js"
export * from "./DraggedItem.vue?vue&type=script&lang=js"

import "./DraggedItem.vue?vue&type=style&index=0&id=701acdcf&scoped=true&lang=scss"

import exportComponent from "/home/devops/tool_cases/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-701acdcf"]])

export default __exports__